
/**
 * Mutation types for Session store
 */
export const SET_USER	= 'SET_SESSION_USER';
export const SET_FACEBOOK_ACCESS_TOKEN = 'SET_FACEBOOK_ACCESS_TOKEN';
